<template>
  <span>
    <v-card>
      <v-card-text>
        <span>
          <v-avatar size="42px">
            <img :src="student.profile.image" class="mr-3">
          </v-avatar>
        </span>
        <span>{{student.profile.given_name}} {{student.profile.family_name}} {{student.profile.ext_name}}</span>
      </v-card-text>
    </v-card>
    <v-divider></v-divider>
  </span>
</template>

<script>
export default {
  props: ['student']
}
</script>



// WEBPACK FOOTER //
// src/components/Student/Classroom/Students.vue